export function hidePhone (tel) {
  if (!tel) return
  var reg = /^(\d{3})\d{4}(\d{4})$/
  return tel.replace(reg, '$1****$2')
}

export function hideCard (card) {
  if (!card) return
  var reg = /^(.{4})(?:\d+)(.{4})$/
  return card.replace(reg, '$1******$2')
}

export function hideEmail (email) {
  if (String(email).indexOf('@') > 0) {
    let newEmail
    let str = email.split('@')
    let _s = ''

    if (str[0].length > 2) {
      _s = str[0].substr(0, 1)
      _s += '****'
      _s += str[0].substr(-1)
      newEmail = _s + '@' + str[1]
    } else {
      newEmail = str[0] + '@' + str[1]
    }
    return newEmail
  } else {
    return email
  }
}

export function debounce (fn, delay) {
  var timer = null
  var count = 0
  return function () {
    var self = this
    var args = arguments
    clearTimeout(timer)
    if (count === 0) {
      timer = setTimeout(function () {
        fn.apply(self, args)
        count++
      }, 500)
    } else {
      timer = setTimeout(function () {
        fn.apply(self, args)
        count++
      }, delay)
    }
  }
}

export function flatRoleList (menus) {
  let parents = menus.filter(item => item.parentId === 0)
  parents.forEach(function (parent) {
    let children = []
    menus.forEach((item) => {
      if (item.parentId === parent.id) {
        children.push(item)
      }
    })
    parent.children = children
  })
  let adminMenus = parents.filter(item => item.parentId === 0)
  return adminMenus
}

export function blobToDataURL (blob, cb) {
  let reader = new FileReader()
  reader.onload = function (evt) {
    let base64 = evt.target.result
    cb(base64)
  }
  reader.readAsDataURL(blob)
}

export function dataURLtoBlob (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export function blobToFile (theBlob, fileName) {
  return new window.File([theBlob], fileName)
}
